import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/GameLibrary",
    component: () => import("@/views/LayoutPage/index.vue"),
    children: [
      // 游戏库
      {
        path: "/GameLibrary",
        name: "GameLibrary",
        component: () => import("../views/GameLibrary/index.vue"),
      },
      // 商品详情页
      {
        path: "/GoodsDetail",
        name: "GoodsDetail",
        component: () => import("../views/GoodsDetail/index.vue"),
      },
      {
        path: "/Login",
        name: "Login",
        component: () => import("../views/Login/index.vue"),
      },
      {
        path: "/VIP",
        name: "VIP",
        component: () => import("../views/VIP/index.vue"),
      },
      {
        path: "/DownLoad",
        name: "DownLoad",
        component: () => import("../views/DownLoad/index.vue"),
      },
    ],
  },
  {
    path: "/AirWallexPay",
    name: "AirWallexPay",
    component: () => import("../views/AirWallexPay/index.vue"),
  },
  // {
  //   path: "/DownLoad",
  //   name: "DownLoad",
  //   component: () => import("../views/DownLoad/index.vue"),
  // },
  {
    path: "/GameWindow",
    name: "GameWindow",
    component: () => import("../views/GameWindow/index.vue"),
  },
  {
    path: "/GameStarter",
    name: "GameStarter",
    component: () => import("../views/GameStarter/index.vue"),
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
